/**
 * THE CLUB'S SALES TAX RATE, REMEMBERED BY EVERY CLUB READ THAT CARRIES IT (D3.16), the way
 * `features/clubs/linkLane.ts` remembers the link lane: a price list that holds only an
 * `orgId` (a desk dialog, a lesson option, an organizer's price input) reads it back with no
 * request of its own.
 *
 * The club reads carry `salesTax: { rateBps }` ONLY while tax is on (ADR §1.4). A read that
 * carries the club's payment facts at all is AUTHORITATIVE — no `salesTax` there means off. A
 * read that does not carry them teaches nothing. A club this tab has not read shows no tax
 * line, exactly as before; a PAYABLE figure never comes from here (it is the server's total).
 */
import { clubTaxRate, type ClubSalesTax } from './taxDisplay'

const known = new Map<string, number | null>()

export function rememberClubTax(
  club: { orgId?: string; salesTax?: ClubSalesTax } | null | undefined,
  authoritative: boolean,
): void {
  const orgId = String(club?.orgId || '').trim()
  if (!orgId) return
  const rate = clubTaxRate(club?.salesTax)
  if (rate !== null || authoritative) known.set(orgId, rate)
}

/** The club's rate while tax is on, else null (off, or not read in this tab). */
export function clubTaxRateOf(orgId: string | null | undefined): number | null {
  return known.get(String(orgId || '').trim()) ?? null
}
